import {
    NDS_ITEM_DELETED,
    NDS_ITEM_SAVED,
    NDS_LOADED,
    NDS_LOADING,
} from "./actionTypes";
import axios from "axios";
import {getConfig} from "./authActions";
import {returnAllErrorsAsPopup, returnErrors} from "./errorActions";
import {getSuccess} from "./successActions";

export const loadNdsItems = () => (dispatch, getState) => {
    dispatch({type: NDS_LOADING});
    axios
        .get(process.env.REACT_APP_API_URL + '/nds' , getConfig(getState))
        .then(res =>
            dispatch({
                type: NDS_LOADED,
                payload: res.data
            })
        )
        .catch(err => {
            dispatch(returnErrors(err));
        });
};

export const saveOrUpdateNdsItem = (ndsItem, onSuccessCallback) => (dispatch, state) => {
    axios
        .post(process.env.REACT_APP_API_URL + '/nds', ndsItem, getConfig(state))
        .then(res => {
                dispatch({type: NDS_ITEM_SAVED});
            }
        )
        .then(() => {
            dispatch(getSuccess({success: "Позиция сохранена"}))
        })
        .then(() => {
            onSuccessCallback && onSuccessCallback()
        })
        .catch(err => {
            dispatch(returnAllErrorsAsPopup(err));
        });
};

export const deleteNdsItem = (id, onSuccessCallback) => (dispatch, state) => {
    axios
        .delete(process.env.REACT_APP_API_URL + '/nds/' + id, getConfig(state))
        .then(res => {
                dispatch({type: NDS_ITEM_DELETED});
            }
        )
        .then(() => {
            dispatch(getSuccess({success: "Позиция удалена"}))
        })
        .then(() => {
            onSuccessCallback && onSuccessCallback()
        })
        .catch(err => {
            dispatch(returnAllErrorsAsPopup(err));
        });
};